<template>
    <div class="text danger mb-0">
        <div>Уважаемые пользователи, в случае вывода активов на неверные реквизиты, Ваши средства могут быть безвозвратно утеряны.</div>
        <div class="pb-4">Убедительная просьба, во избежание потери активов перепроверяйте реквизиты несколько раз!!!</div>
        <div>Уважаемые пользователи, компания Биток плюс не несет ответственности за потерю активов при отправке средств на неверные реквизиты</div>
    </div>
</template>